import React, { useState, useEffect } from "react";
import { X } from "react-bootstrap-icons";
import "../../Custom.css"; // custom styles

const DateDrawer = ({ isOpen, onClose, onSave, initialDate }) => {
  const [selectedDate, setSelectedDate] = useState("");
  const [hours, setHours] = useState("12");
  const [minutes, setMinutes] = useState("00");
  const [ampm, setAmpm] = useState("AM");

  useEffect(() => {
    if (initialDate) {
      const date = new Date(initialDate);
      setSelectedDate(date.toISOString().split("T")[0]);

      let hrs = date.getHours();
      const isAM = hrs < 12;
      hrs = hrs % 12;
      hrs = hrs ? hrs : 12;

      setHours(String(hrs).padStart(2, "0"));
      setMinutes(String(date.getMinutes()).padStart(2, "0"));
      setAmpm(isAM ? "AM" : "PM");
    }
  }, [initialDate]);

  const handleSave = () => {
    if (selectedDate && hours && minutes) {
      let hour24 = parseInt(hours);
      if (ampm === "PM" && hour24 !== 12) {
        hour24 += 12;
      } else if (ampm === "AM" && hour24 === 12) {
        hour24 = 0;
      }

      const timeStr = `${String(hour24).padStart(2, "0")}:${minutes}:00`;
      const dateTime = new Date(`${selectedDate}T${timeStr}`);
      onSave(dateTime.toISOString());
    }
  };

  const formatPreviewDate = () => {
    if (!selectedDate || !hours || !minutes)
      return "Please select both date and time";

    const date = new Date(selectedDate);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yy = String(date.getFullYear()).slice(-2);

    return `${dd}/${mm}/${yy}  ${hours}:${minutes} ${ampm}`;
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="drawer-overlay" onClick={onClose} />}

      {/* Drawer */}
      <div className={`drawer ${isOpen ? "open" : ""}`}>
        <div className="drawer-content">
          {/* Header */}
          <div className="drawer-header bg-light d-flex justify-content-between align-items-center p-3 border-bottom">
            <h5 className="mb-0">Configure Wait Date</h5>
            <button
              type="button"
              className="btn btn-link text-muted p-0"
              onClick={onClose}
            >
              <X size={24} />
            </button>
          </div>

          {/* Body */}
          <div className="drawer-body p-3 flex-grow-1">
            {/* Date Selection */}
            <div className="mb-3">
              <label className="form-label fw-medium">Select Date</label>
              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="form-control"
              />
            </div>

            {/* Time Selection */}
            <div className="mb-3">
              <label className="form-label fw-medium">Select Time</label>
              <div className="d-flex align-items-center gap-2">
                {/* Hours */}
                <select
                  value={hours}
                  onChange={(e) => setHours(e.target.value)}
                  className="form-select w-auto"
                >
                  {[12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((h) => (
                    <option key={h} value={String(h).padStart(2, "0")}>
                      {String(h).padStart(2, "0")}
                    </option>
                  ))}
                </select>

                <span className="fw-bold">:</span>

                {/* Minutes */}
                <select
                  value={minutes}
                  onChange={(e) => setMinutes(e.target.value)}
                  className="form-select w-auto"
                >
                  {Array.from({ length: 60 }, (_, i) => (
                    <option key={i} value={String(i).padStart(2, "0")}>
                      {String(i).padStart(2, "0")}
                    </option>
                  ))}
                </select>

                {/* AM/PM */}
                <select
                  value={ampm}
                  onChange={(e) => setAmpm(e.target.value)}
                  className="form-select w-auto"
                >
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              </div>
            </div>

            {/* Preview */}
            <div className="bg-light p-3 rounded border">
              <h6 className="mb-2">Preview</h6>
              <p className="text-muted mb-0 font-monospace">
                {formatPreviewDate()}
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="drawer-footer bg-light p-3 border-top d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-info text-white"
              onClick={handleSave}
              disabled={!selectedDate || !hours || !minutes}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DateDrawer;
